<div class="container-fluid">
    <h2 class="title-interests">Centres d'intérêts</h2>
    <div class="row">
        <div class="col-lg-6 offset-lg-3 cloud">
            <img src="assets/cloud.PNG" class="cloud-img">
        </div>
    </div>
</div>